import { useEffect, useState } from "react";
import api from "../services/api";

// Browser-native media elements cannot supply the JWT header required by
// protectPublicMedia. Fetch through the existing authenticated API instead.
export default function useAuthenticatedMedia(url) {
  const [objectUrl, setObjectUrl] = useState("");
  useEffect(() => {
    let active = true;
    let createdUrl = "";
    setObjectUrl("");
    if (!url) return undefined;
    const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    api.get(url, { responseType: "blob", ...(controller ? { signal: controller.signal } : {}) })
      .then(({ data }) => {
        if (!active) return;
        createdUrl = URL.createObjectURL(data);
        setObjectUrl(createdUrl);
      })
      .catch(error => {
        if (active) console.error("Não foi possível carregar a mídia autenticada", error);
      });
    return () => {
      active = false;
      if (controller) controller.abort();
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [url]);
  return objectUrl;
}
